<template>
    <div class="bg-white">
        <div class="p-5 md:py-12 xl:py-24 2xl:py-32 login-page border-b border-gray-200">
            <div class="mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4">
                <p class="font-medium text-center p-2">
                    <template v-if="data.hasOwnProperty('consumerPortalNumber') && data.hasOwnProperty('consumerPortalEmail')">
                        In order to proceed please contact our office at
                        <a :class="`font-semibold text-${$root.theme}-500 whitespace-nowrap`" :href='`tel:${data.consumerPortalNumber}`'>
                            <svg class="inline-block w-5 h-5 mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"/>
                            </svg>
                            {{ data.consumerPortalNumber }}
                        </a>
                        or email us at
                        <a :class="`font-semibold text-${$root.theme}-500 whitespace-nowrap`" :href='`tel:${data.consumerPortalEmail}`'>
                            {{ data.consumerPortalEmail }}
                        </a>
                    </template>
                    <template v-else-if="data.hasOwnProperty('consumerPortalNumber') && ! data.hasOwnProperty('consumerPortalEmail')">
                        In order to proceed please contact our office at <a :href="`tel:${data.consumerPortalNumber}`" :class="`font-semibold text-${$root.theme}-500`">{{ data.consumerPortalNumber }}.</a>
                    </template>
                    <template v-else-if="data.hasOwnProperty('consumerPortalEmail') && ! data.hasOwnProperty('consumerPortalNumber')">
                        In order to proceed please email our office at <a :href="`mailto:${data.consumerPortalEmail}`" :class="`font-semibold text-${$root.theme}-500`">{{ data.consumerPortalEmail }}.</a>
                    </template>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['data']
    }
</script>
